import Vue from 'vue'
import { API_URL } from '@/config'

export const presentations = {

  namespaced: true,

  state: {
    filters: [
      { column: 'id', label: 'id', options: { type: false }, value: '', status: true },
      // { column: 'assignments', label: 'assignments', options: { type: false }, value: '', status: true },
      { column: 'title', label: 'title', options: { type: false }, value: '', status: true },
    ],
    options: {
      id: { label: 'id', element: 'text' },
      // assignments: { label: 'assignments', element: 'text' },
      title: { label: 'title', element: 'text' },
    },
    presets: [],
    columns: [],
    presentations: [],
    imported: {},
    sort: {
      column: 'id',
      columns: [
        { column: 'id', order: 'asc' },
      ],
      order: 'asc'
    },
    total: 0,
    subtotal: 0,
    offset: 0,
  },

  getters: {
    filters: state => state.filters,
    options: state => state.options,
    presets: state => state.presets,
    columns: state => state.columns,
    presentations: state => state.presentations,
    imported: state => state.imported,
    sort: state => state.sort,
    total: state => state.total,
    subtotal: state => state.subtotal,
    offset: state => state.offset,
  },

  mutations: {
    setFilters(state, filters) { state.filters = filters },
    setOptions(state, options) { state.options = options },
    setPresets(state, presets) { state.presets = presets },
    setColumns(state, columns) { state.columns = columns },
    setPresentations(state, presentations) { state.presentations = state.presentations.concat(presentations) },
    setImported(state, imported) { state.imported = imported },
    setSort(state, sort) { state.sort = sort },
    setTotal(state, total) { state.total = total },
    setSubtotal(state, subtotal) { state.subtotal = subtotal },
    setOffset(state, offset) { state.offset = offset },
    clearFilters(state) {
      state.filters = [
        { column: 'id', label: 'id', options: { type: false }, value: '', status: true },
        // { column: 'assignments', label: 'assignments', options: { type: false }, value: '', status: true },
        { column: 'title', label: 'title', options: { type: false }, value: '', status: true },
      ];
      state.options = {
        id: { label: 'id', element: 'text' },
        // assignments: { label: 'assignments', element: 'text' },
        title: { label: 'title', element: 'text' },
      };
    },
    clearList(state) {
      state.presentations = [];
      state.total = 0;
      state.subtotal = 0;
      state.offset = 0;
    },
  },

  actions: {

    getOptions: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Presentation'],
      filter_display: true,
    }}),

    getColumns: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Presentation'],
      list_display: true,
    }}),

    getPresentations: ({ rootState, getters }) => Vue.axios.get(API_URL + '/presentations', { params: {
      filters: (['admin','user', 'secretariat'].includes(rootState.user.role_id)) ? getters.filters : [{ column: 'assigned_to_private_session', value: 'no', custom: true, status: true }].concat(getters.filters),
      offset: getters.offset,
      sorts: getters.sort.columns,
    }}),

    async getList({ state, getters, commit, dispatch }) {
      const [options, columns, presentations] = await Promise.all([
        dispatch('getOptions'),
        dispatch('getColumns'),
        dispatch('getPresentations'),
      ])
      .catch(() => {
        commit('setProgress', false, { root: true });
      });
      commit('setProgress', false, { root: true });
      commit('setOptions', options.data['App\\Models\\Presentation'].filters);
      commit('setPresets', options.data['App\\Models\\Presentation'].presets);
      commit('setColumns', columns.data['App\\Models\\Presentation']);
      commit('setPresentations', presentations.data.items);
      commit('setTotal', presentations.data.total);
      commit('setSubtotal', presentations.data.subtotal);
      commit('setOffset', getters.presentations.length);
      state.options.type = {
        format: 'wording',
        label: 'type',
        element: 'radio',
        custom: true,
        options: [
          { value: 'abstract', name: 'abstract' },
          { value: 'presentation', name: 'presentation' },
        ],
      };
      state.options.assigned = {
        format: 'wording',
        label: 'assigned',
        element: 'radio',
        custom: true,
        options: [
          { value: 'yes', name: 'yes' },
          { value: 'no', name: 'no' },
        ],
      };
      state.options.conflict = {
        format: 'wording',
        label: 'conflicts',
        element: 'radio',
        custom: true,
        options: [
          { value: 'has_overlap_participations', name: 'has_overlap_participations' },
        ],
      };
      state.options.comment_status = {
        format: 'wording',
        label: 'comment_status',
        element: 'radio',
        custom: true,
        options: [
          { value: 'without', name: 'without' },
          { value: 'ready', name: 'ready' },
          { value: 'open', name: 'open' },
          { value: 'problem', name: 'problem' },
          { value: 'error', name: 'error' },
        ],
      };
      state.options.participation_status = {
        format: 'wording',
        label: 'participation_status',
        element: 'radio',
        custom: true,
        options: [
          { value: 'not_invited', name: 'not_invited' },
          { value: 'invited', name: 'invited' },
          { value: 'confirmed', name: 'confirmed' },
          { value: 'declined', name: 'declined' },
        ],
      };
    },

    async addPresentations({ getters, commit, dispatch }) {
      const presentations = await dispatch('getPresentations');
      commit('setProgress', false, { root: true });
      commit('setPresentations', presentations.data.items);
      commit('setOffset', getters.presentations.length);
    }, 

    async sortPresentations({ rootState, commit, dispatch, getters }, data) {
      if (!rootState.progress) {
        let order = getters.sort.column === data.column 
          ? getters.sort.order === 'asc' ? 'desc' : 'asc'
          : 'asc';
        let columns = data.columns.reduce((carry, column) => { 
          carry.push({ column: column, order: order });
          return carry;
        }, []);
        commit('setSort', { column: data.column, columns: columns, order: order });
        commit('clearList');
        await dispatch('getList');
      }
    }

  }

}
